<template>
  <div class="selected-fertilizer">
    <div class="header">
      <h2>
        {{ $ml.get(`Selected fertilizer`) }}
        <info-tip :title="$ml.get(`Select the fertilizers available in your farm and push the button recalculate`)"/>
      </h2>
      <div>

        <app-btn
          w-auto
          @click="openPopup = !openPopup"
          :disabled="$store.getters['program/data'].finished == 1"
          >
          {{ $ml.get(`ADD FERTILIZERS`) }}
        </app-btn>

      </div>
    </div>
    <!-- <table class="a-table" v-if="selectedFertilizers.length" :class="{blur : (!$store.getters['user/data'].subsPlan)}">
      <app-btn to="/dashboard/plans" class="go-to-plans" v-if="!$store.getters['user/data'].subsPlan">{{$ml.get(`Get the full access to the software`)}}</app-btn>

      <tr class="head">
        <td>{{ $ml.get(`Fertilizer`) }}</td>
        <td>{{ $ml.get(`Quantity`) }}</td>
        <td></td>
      </tr>
      <tr v-for="(fertilizer, i) in selectedFertilizers" :key="fertilizer.id">
        <td>{{ fertilizer.fertilizer.name }}</td>
        <td>
          <span>
            <template v-if="selectedFertilizers[i].quantity">{{(selectedFertilizers[i].quantity).toFixed(3)}} {{selectedFertilizers[i].unit}}</template>
            <template v-else>-</template>
          </span>
        </td>
        <td>
          <app-btn
            styling="outline"
            @click="deleteFertilizer($route.params.programId, fertilizer.fertilizer.id)"
          >
            {{ $ml.get(`delete`) }}
          </app-btn>
        </td>
      </tr>
    </table> -->
    <div class="buttons">
      <app-btn
        @click="toggleManual"
        styling="outline"
        class="manual"
        :disabled="$store.getters['program/data'].finished == 1"
      >
        {{ manual ? $ml.get(`Save`) : $ml.get(`Manual adjustment`) }}
      </app-btn>
    </div>
    <table class="a-table" v-if="result && result.SelectedFertilizers.Fertilizers.length" :class="{blur : (!$store.getters['user/data'].subsPlan)}">
      <app-btn to="/dashboard/plans" class="go-to-plans" v-if="!$store.getters['user/data'].subsPlan">{{$ml.get(`Get the full access to the software`)}}</app-btn>



      <tr class="head">
        <td>{{ $ml.get(`Fertilizer`) }}</td>
        <td>{{ $ml.get(`Quantity`) }}</td>
        <td>{{ $ml.get(`Cost`) }}</td>
        <!-- <td>{{ $ml.get(`Actions`) }}</td> -->
      </tr>
      <tr v-for="(fertilizer, i) in result.SelectedFertilizers.Fertilizers" :key="fertilizer.Id">
        <td>{{ fertilizer.Name }}</td>
        <td>

          <span v-if="!manual">
            <template v-if="fertilizer.Concentration">
              {{$store.getters['user/data'].units.toLowerCase() === 'us' ? $store.getters['unit/convert']('kg', fertilizer.Concentration) : fertilizer.Concentration.toFixed(2)}}
              {{$store.getters['unit/getLabel'](fertilizer.ConcentrationUnit)}}
              <!-- {{(fertilizer.Concentration).toFixed(3)}} {{fertilizer.ConcentrationUnit}} -->
            </template>
            <template v-else>-</template>
          </span>

          <app-text-input
            v-else
            v-model="fertilizer.Concentration"
            :hint="$store.getters['unit/getLabel'](fertilizer.ConcentrationUnit)"
            @input="validate(i)"
          />


        </td>
        <td>
          <template v-if="fertilizer.Cost">{{ $store.getters['user/currency'].symbol }} {{ (fertilizer.Cost).toFixed(2) }}</template>
          <template v-else>0</template>
        </td>
        <!-- <td>
          <app-btn
            styling="danger-outline"
            @click="deleteFertilizer($route.params.programId, fertilizer.Id)"
          >
            {{ $ml.get(`delete`) }}
          </app-btn>
        </td> -->
      </tr>

      <tr>
        <td>
          {{ $ml.get(`Total`) }}
        </td>
        <td></td>
        <td><b>{{ $store.getters['user/currency'].symbol }} {{ totalCost }}</b></td>
        <td></td>
      </tr>

    </table>

    <SelectFertilizer
      @updateFertilizers="upData"
      :open="openPopup"
      v-model="fertilizers"
      :dressing="true"
    />

    <div class="actions">
      <app-btn @click="recalculate" class="recalculate" v-if="result !== null">
        {{ $ml.get(`RECALCULATE`) }}
      </app-btn>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import SelectFertilizer from "@/components/program/fertilizerSel/SelectFertilizer"

export default {
  props: {
    result: {},
    recFlag: Boolean,
    loading: Boolean
  },
  data () {
    return {
      openPopup: true,
      fertilizers: [],
      selectedFertilizers: [],
      manual: false,
    }
  },
  created() {
    // console.log(this.result);
    // this.sync();
  },
  components: {
    SelectFertilizer
  },
  computed: {
    totalCost() {
      let _total = 0;
      this.result.SelectedFertilizers.Fertilizers.forEach(el => {
        _total += el.Cost;
      })

      return _total.toFixed(2);
    },
  },
  watch: {
    recFlag: function (val) {
      this.recalculate();
    },
    // loading: function (val) {
    //   if (!val) {
    //     this.sync();
    //   }
    // }
  },
  methods: {
    validate(i) {
      let fertilizers = this.result.SelectedFertilizers.Fertilizers;
      let conc = fertilizers[i].Concentration
      fertilizers[i].Concentration = conc > 0 ? conc : -conc
    },
    toggleManual() {
      const units = this.$store.getters['user/data'].units;
      this.manual ^= true;
      if(this.manual == true && units.toLowerCase() === 'us') {
        this.result.SelectedFertilizers.Fertilizers.forEach(el => {
          console.log(el.Concentration)
          el.Concentration = this.$store.getters['unit/convert']('kg', el.Concentration)
          console.log(el.Concentration)
        })
      }
      if(this.manual == false) this.$emit('manual');
    },
    async upData () {
      // console.log('hey');
      await this.sync();
      this.recalculate();
    },
    async sync() {
      var data = await API.fertilizers
        .getSelectedFertilizersDressing({ programId: this.$route.params.programId })
        .then(res => res.data.data)
      if(data.length <= 0) {
        this.result['SelectedFertilizers']['Fertilizers'] = [];
        this.selectedFertilizers = [];
        // console.log('length <= 0');
        return;
      }
      this.selectedFertilizers = data.map(n => {
        if(this.result) {
          const fert = this.result['SelectedFertilizers']['Fertilizers']
            .find(z => z.Id == n.fertilizer.id);
          // console.log(fert);
          n.quantity = fert ? fert.Concentration : 0;
          n.unit = fert ? fert.ConcentrationUnit : 'kg';
        }
        return n;
      });
      // console.log(this.selectedFertilizers);
      // console.log(data, this.result);
    },
    deleteFertilizer(programId, fertilizerId) {
      return API.fertilizers.deletSelectedFertilizersDressing({ programId: programId, fertilizerId: fertilizerId }).then(res => {
        if(res.data.success) {
          // this.sync();
          this.upData();
        }
      })
    },
    recalculate() {
      // if (this.selectedFertilizers.length > 0) {
        this.$emit('recalculate', this.selectedFertilizers);
      // }
    },
    // recalculateByQuantity() {
    //   return API.fertilizers.updateQuantityBaseDressing().then(res => {
    //     console.log(res.data);
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>

.selected-fertilizer {
  .actions {
    margin-top: 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: flex-end;
  }
  padding-top: 40px;
  .helper-question-mark {
    margin-right: 16px;
  }
  .header {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding-bottom: 20px;

    h2 {
      display: flex;
    }

    &> div:last-child {
      display: flex;
      align-items: center;
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    .manual {

    }
  }
  table {
    width: 100%;
    .app-text-input {
      width: 200px;
    }

  }
  .recalculate {
    margin-bottom: 24px;
    margin-top: 24px;
  }
  @media (max-width: 768px) {
    .header {
      flex-direction: column;
      align-items: flex-start;
    }
    table.a-table {

      tr {
        &.head {
          display: none;
        }
        td {
          padding: 8px 4px;
          &:nth-child(2) {
            display: none;
          }
        }
      }
    }
  }
}

</style>
